<template>
  <div class="text-black overflow-x-hidden">
    <div class="flex items-center justify-center">

        <div class="text-center flex flex-col">
          <div class="p-1 pt-2">
            <span class="text-lg">You can send feedback using the form below.</span>
          </div>
          <p v-if='validationErrorEmail' class="float-left mr-2 text-red-500 text-xs italic">Please enter an email.</p>
          <p v-if='validationErrorName' class="text-red-500 text-xs italic">Please enter your comment.</p>

          <apollo-mutation
            :mutation="signupMutation"
            :update='setSignedUp'
            class="flex flex-col w-full p-2 bg-gray-300 border border-gray-400 rounded"
            :variables="{name:name + ' [' + location + ']',email:email+getToken()}">

            <template v-slot="{mutate,loading,error,result}" >
              <div v-if='loading' class="spinner grow" />
              <input v-if='!signedUp && !loading' 
                     v-model='email'
                     class="w-48 shadow appearance-none border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline m-2"
                     id="email"
                     type="text"
                     placeholder="Email to use for reply"
                     />
              <textarea v-if='!signedUp && !loading'
                        v-model='name'
                        class="shadow appearance-none border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline m-2"
                        id="name"
                        type="text"
                        placeholder="Your message." />
              <div v-if='signedUp' class="w-full text-center text-green-700">Thanks! Join us on Discord!</div>
              <pbc-button v-if='!signedUp && !loading' class="mt-2 pbc-primary-color mx-auto p-2 text-lg" @click='signup(mutate)'>Send</pbc-button>
            </template>
          </apollo-mutation>

          <p class="p-5 pt-12 text-lg">
            Or email us at
            <a href="mailto:nico@playboxcade.com" class="text-blue-600">nico@playboxcade.com</a>
          </p>

          <div class="p-5 pt-12 text-lg">
            <span class="text-sm">Our Discord is the best place to get help, give feedback, or to just have a chat.</span>
          </div>
          <div class="grow">
            <iframe class="mx-auto " style="min-height: 300px" src="https://discordapp.com/widget?id=594268401023713280&theme=dark" max-width="350" max-height="500" allowtransparency="false" frameborder="0" ></iframe>
            <div class="p-5 text-center">
              <div class="text-lg tracking-tight">
                Or join us on reddit
              </div>
              <div class="flex flex-row justify-center">
                <a target="_blank" class="text-blue-600 underline" href="https://www.reddit.com/r/Playboxcade">
                  <img src="/1400850.svg" class="mr-4 w-8 h-8 float-left"/>
                  here
                </a>
              </div>
            </div>
          </div>


        </div>


      </div>

  </div>
</template>
<script>
import gql from 'graphql-tag';
import { ApolloMutation } from 'vue-apollo';
export default {
  props:{
    location:{
      type:String,
      default() {
        return window.location.href;
      }
    }
  },
  components: {
    ApolloMutation,
  },
  mounted() {
    this.$ana.track({
      eventCategory:'ui',
      eventAction:'openFeedback'
    });
  },
  beforeDestroy() {
    this.$ana.track({
      eventCategory:'ui',
      eventAction:'closeFeedback'
    });
  },
  methods: {
    getToken() {
      return ':'+Math.floor(Math.random() * 10000);
    },
    setSignedUp() {
      this.signedUp = true;

      this.$ana.track({
        eventCategory:'ui',
        eventAction:'sendFeedback'
      });
    },
    async signup(mutate) {
      this.validationErrorName = false;
      this.validationErrorEmail = false;
      if (this.email.indexOf('@') === -1) {
        this.validationErrorEmail = true;
      }
      if (!this.name) {
        this.validationErrorName = true;
      }
      if (this.validationErrorName || this.validationErrorEmail) {
        return;
      }
      await mutate();
    }
  },
  data() {
    const signupMutation = gql(`
      mutation signupEmail($email: String!, $name: String!) {
        signupEmail(email: $email, name: $name)
      }
    `);
    return {
      signupMutation,
      name:'',
      email:'',
      signedUp:false,
      validationErrorEmail:false,
      validationErrorName:false
    }
  },
}
</script>


